import type { Event_Card } from "~/core";

export const isEventCard = (item: unknown): item is Event_Card => {
  return (
    typeof item === "object" &&
    item !== null &&
    "__typename" in item &&
    item.__typename === "event_card"
  );
};
